// extracted by mini-css-extract-plugin
export default {"expanded-badge":"expanded-badge--mp-sro66","expandedBadge":"expanded-badge--mp-sro66"};